import { c as _c } from "react/compiler-runtime";
import React, { useRef } from 'react';
import classNames from 'classnames';
import PropTypes from 'prop-types';
import useKeyboardControlForTabs from 'hooks/useKeyboardControlForTabs';

// Boxed two-up tabs for the revamp info panel; same tab markup as TabPanel
const PDPInfoSegmentedTabs = t0 => {
  const $ = _c(18);
  const {
    "aria-label": ariaLabel,
    items,
    selectedTab,
    onSelectTab
  } = t0;
  const tabsRef = useRef(null);
  useKeyboardControlForTabs(tabsRef);
  let t1;
  if ($[0] !== items || $[1] !== onSelectTab || $[2] !== selectedTab) {
    let t2;
    if ($[4] !== onSelectTab || $[5] !== selectedTab) {
      t2 = (t3, index) => {
        const {
          id,
          label
        } = t3;
        const isSelected = id === selectedTab;
        return <button key={id} id={id} type="button" role="tab" aria-controls={`${id}-content`} aria-selected={isSelected ? "true" : "false"} tabIndex={isSelected ? undefined : "-1"} onClick={() => onSelectTab(id)} className={classNames("flex-1 py-3 px-4 border border-solid bg-transparent text-base text-center cursor-pointer", "focus:outline-none focus-visible:outline focus-visible:outline-2 focus-visible:outline-brand focus-visible:-outline-offset-2", {
          "-ml-px": index > 0,
          "relative z-10 border-gray-dark text-gray-dark font-bold": isSelected,
          "border-gray-light6 text-gray-light2 hover:text-gray-dark": !isSelected
        })}>{label}</button>;
      };
      $[4] = onSelectTab;
      $[5] = selectedTab;
      $[6] = t2;
    } else {
      t2 = $[6];
    }
    t1 = items.map(t2);
    $[0] = items;
    $[1] = onSelectTab;
    $[2] = selectedTab;
    $[3] = t1;
  } else {
    t1 = $[3];
  }
  let t2;
  if ($[7] !== ariaLabel || $[8] !== t1) {
    t2 = <div ref={tabsRef} role="tablist" aria-label={ariaLabel} className="flex">{t1}</div>;
    $[7] = ariaLabel;
    $[8] = t1;
    $[9] = t2;
  } else {
    t2 = $[9];
  }
  let t3;
  if ($[10] !== items || $[11] !== selectedTab) {
    let t4;
    if ($[13] !== selectedTab) {
      t4 = t5 => {
        const {
          id: id_0,
          content
        } = t5;
        return <div key={id_0} id={`${id_0}-content`} role="tabpanel" aria-labelledby={id_0} tabIndex="0" hidden={id_0 !== selectedTab ? true : undefined} className="pt-4 [&[hidden]]:hidden">{content}</div>;
      };
      $[13] = selectedTab;
      $[14] = t4;
    } else {
      t4 = $[14];
    }
    t3 = items.map(t4);
    $[10] = items;
    $[11] = selectedTab;
    $[12] = t3;
  } else {
    t3 = $[12];
  }
  let t4;
  if ($[15] !== t2 || $[16] !== t3) {
    t4 = <div>{t2}{t3}</div>;
    $[15] = t2;
    $[16] = t3;
    $[17] = t4;
  } else {
    t4 = $[17];
  }
  return t4;
};
PDPInfoSegmentedTabs.propTypes = {
  'aria-label': PropTypes.string.isRequired,
  items: PropTypes.arrayOf(PropTypes.shape({
    id: PropTypes.string.isRequired,
    label: PropTypes.string.isRequired,
    content: PropTypes.node
  })).isRequired,
  selectedTab: PropTypes.string,
  onSelectTab: PropTypes.func.isRequired
};
export default PDPInfoSegmentedTabs;